<template>
<w-main-template>
  <!-- side -->
  <div slot="sideContent">
    <w-setting-work-sliding-popup ref="settingWorkPopup" :popup-params="popupParams" @close="onSettingPopupClose"></w-setting-work-sliding-popup>
    <datepicker class="nav-calendar" :inline="true" language="ko" :value="navigationDate" :highlighted="highlighted" format="yyyy-MM-dd" @selected="selectNavigationDate" @changedMonth="onChangedDatepicker" />
    <div class="calender-work-list">
      <h4>작업 별 필터링</h4>
      <el-checkbox-group v-model="filteringConfig.workType">
        <el-row type="flex" justify="start" :gutter="5" v-for="work in filteringDatas.workType" :key="work.basicinfoSubid">
          <el-checkbox :label="work.basicinfoSubid">
            <div class="txt">
              {{work.basicinfoSubname}}
              <div :class="getWorkTypeStyleClass(work.basicinfoSubid)"></div>
            </div>
            <div class="num">{{work.cnt}} 건</div>
          </el-checkbox>
        </el-row>
      </el-checkbox-group>
      <h4>영향도별 작업내역</h4>
      <el-checkbox-group v-model="filteringConfig.workImpact">
        <el-row type="flex" justify="start" :gutter="5" v-for="work in filteringDatas.workImpact" :key="work.basicinfoSubid">
          <el-checkbox :label="work.basicinfoSubid">
            <div class="txt">
              {{work.basicinfoSubname}}
              <div class="impact-work-box" :style="{ backgroundColor: filteringColor[work.basicinfoSubid] }"></div>
            </div>
            <div class="num">{{work.cnt}} 건</div>
          </el-checkbox>
        </el-row>
      </el-checkbox-group>
      <h4>스케줄링</h4>
      <el-checkbox-group v-model="filteringConfig.workSchedule">
        <el-row type="flex" justify="start" :gutter="5" v-for="work in filteringDatas.workSchedule" :key="work.basicinfoSubid">
          <el-checkbox :label="work.basicinfoSubid">
            {{work.basicinfoSubname}} {{work.cnt}} 건
          </el-checkbox>
        </el-row>
      </el-checkbox-group>
    </div>
  </div>
  <!-- title -->
  <w-main-title slot="mainTitle" title="전체 일정">
    <div slot="rightTool">
      <el-button size="medium" type="solid" @click="this.openAmsSlidingPopup">자동화 수행</el-button>
      <w-report-button/>
    </div>
  </w-main-title>
  <!-- main -->
  <div slot="mainContent" class="full-wrapper">
    <el-scrollbar :ref="scrollbarRef">
      <div class="full">
        <w-calendar-header :current-date="selectedDate" @change="changeMonth">
          <!-- add 1203 margin  -->
          <el-radio-group style="margin-bottom: 3.5px" slot="header-left" v-model="viewType">
            <el-radio-button label="CALENDAR">월간</el-radio-button>
            <el-radio-button label="LIST">목록</el-radio-button>
          </el-radio-group>
          <el-button v-show="viewType === 'CALENDAR'" slot="header-center" type="secondary" size="small" @click="settingWorkPopupOpen('ADD')">작업 추가</el-button>
          <el-input v-show="viewType === 'CALENDAR'" slot="header-right" size="small" v-model="calendarFilterValue" placeholder="검색 키워드를 입력해주십시오." @keyup.native.enter="searchFilter">
            <i class="el-input__icon el-icon-search" slot="suffix" style="cursor: pointer" @click="searchFilter"></i>
          </el-input>
          <w-header-search-button v-show="viewType === 'LIST'" slot="header-right" @click="onClickTableSearchButton"></w-header-search-button>
        </w-calendar-header>
        <w-work-calendar v-show="viewType === 'CALENDAR'" @workClick="openDatailPopup" :selected-date="selectedDate" :filtering-config="filteringConfig" @day-click="selectDate" @calendar-number-click="onClickCalendarNumber" ref="workCalendar"></w-work-calendar>
        <w-work-list-table v-show="viewType === 'LIST'" @add-column-click="onClickAddColumn" @workClick="openDatailPopup" :selected-date="selectedDate" :filtering-config="filteringConfig" ref="workListTable"></w-work-list-table>
        <w-ams-sliding-popup ref="amsSlidingPopup"></w-ams-sliding-popup>
      </div>
    </el-scrollbar>
    <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</w-main-template>
</template>


<script>
import workManageAPI from '@/api/work/work';
import moment from 'moment';
import { isNil, sortBy, reverse, isEmpty } from 'lodash';
import ScrollbarMixin from '@/mixins/scrollbar';
import WMainTemplate from '@/components/template/MainTemplate';
import WMainTitle from '@/components/template/MainTitle';
import WReportButton from '@/components/button/ReportButton';
import Datepicker from '@/components/external/vuejs-datepicker/components/Datepicker';
import WSettingWorkSlidingPopup from './popup/SettingWorkSlidingPopup';
import WCalendarHeader from './components/CalendarHeader';
import WWorkCalendar from './components/WorkCalendar';
import WWorkListTable from './components/WorkListTable';
import WAmsSlidingPopup from './popup/AmsSlidingPopup';

export default {
  name: 'WWork',
  mixins: [ScrollbarMixin],
  components: {
    WMainTemplate,
    Datepicker,
    WCalendarHeader,
    WSettingWorkSlidingPopup,
    WWorkCalendar,
    WWorkListTable,
    WReportButton,
    WMainTitle,
    WAmsSlidingPopup,
  },
  data() {
    return {
      highlighted: {
        ranges: [],
      },
      navigationDate: new Date(), // date-picker 네비게이션 현재 날짜
      selectedDate: new Date(), // 작업내역 (달력/목록) 현재 날짜
      viewType: 'CALENDAR',
      popupParams: {},
      showSearchTool: false,
      calendarFilterValue: '',
      filteringDatas: [],
      filteringColor: {
        // 색상 변경될 시 변경 필요 datepicker, fullcalendar 기준 처리 / ./components/WorkListTable.vue 화면도 변경 필요
        // NOTICE: 다음 컴포넌트와 색상은 항상 동기화해야함.
        // src\components\external\vuejs-datepicker\components\Datepicker.vue
        // src\components\external\vue-fullcalendar\components\body.vue
        // 본 컴포넌트 스타일에서 .work-filtering-box 하위 각 작업별 색상도 동기화해야함.
        GRADE_A: '#e94949',
        GRADE_B: '#ffa500',
        GRADE_C: '#51a961',
        GRADE_D: '#2d87d0',
        GRADE_NULL: '#bebebe',
        CHANGE: '#e3f3ef',
        CHECK: '#f0e7f7',
        CONSTRUCT: '#e5f2ff',
      },
      filteringConfig: {
        // 체크박스 checked 처리
        workImpact: ['GRADE_A', 'GRADE_B', 'GRADE_C', 'GRADE_D', 'GRADE_NULL'],
        workSchedule: ['D', 'M', 'O', 'W'],
        workType: ['CHANGE', 'CHECK', 'CONSTRUCT'],
      },
      basicinfoSubDatas: {},
    };
  },
  computed: {
    autoMoveMenuInfo() {
      return this.$store.getters.autoMoveMenuInfo;
    },
    showWorkDetailsSlidingPopup() {
      /* 작업 상세 팝업 공통으로 관리 */
      return this.$store.state.popup.showWorkDetailsSlidingPopup;
    },
    workDetailsSlidingPopupParams() {
      return this.$store.state.popup.workDetailsSlidingPopupParams;
    },
  },
  watch: {
    autoMoveMenuInfo: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val)) {
          if (val[0].id === 'amsSlidingPopup') {
            this.$nextTick(() => {
              this.openAmsSlidingPopup();
            });
          }
          if (val.length === 1) {
            this.$store.dispatch('setAutoMoveMenuInfo', null);
          }
        }
      },
    },
    showWorkDetailsSlidingPopup: {
      handler(to, from) {
        const isClose = !to && from;
        if (isClose) {
          // WorkDetailsSlidingPopup close 감지
          this.reloadStore();
        }
      },
    },
    workDetailsSlidingPopupParams: {
      handler(param) {
        if (param.updateFlag) {
          // WorkDetailsSlidingPopup update-button-click 감지
          const workUpdatePopupParams = param.workUpdatePopupParams;
          this.settingWorkPopupOpen('UPDATE', workUpdatePopupParams);
        }
      },
    },
  },
  /**
   * [created 데이터 출력]
   * @author {Yang}
   * @return {[type]} [description]
   */
  created() {
    new Promise((resolve) => {
      this.onChangedDatepicker(this.selectedDate);
      resolve();
    }).then(() => {
      this.basicinfoSubloadStore();
    });
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    /**
     * date-picker 네비게이션 date select
     * @author jeee12
     * @param  {[type]} selectedNav [description]
     */
    selectNavigationDate(selectedNav) {
      this.navigationDate = selectedNav;
      this.selectedDate = selectedNav;
    },
    /**
     * 작업내역 달력/목록 date select
     * @author jeee12
     * @param  {[type]} selectedDate [description]
     */
    selectDate(selectedDate) {
      this.selectedDate = selectedDate;
    },
    settingWorkPopupOpen(popupType, updateParams) {
      const selectedDate = moment(this.selectedDate).format('YYYY-MM-DD');
      const popupParams = {
        popupTitle: popupType === 'ADD' ? `작업 추가 [${selectedDate}]` : '작업 수정',
        popupType,
        selectedDate: this.selectedDate,
        workTypeDatas: this.basicinfoSubDatas.workType,
        workImpactDatas: this.basicinfoSubDatas.workImpact,
      };
      if (updateParams) popupParams.updateParams = updateParams;
      this.popupParams = popupParams;
      this.$refs.settingWorkPopup.open();
    },
    /**
     * [onClickAddColumn 작업내역 목록에서 작업추가]
     * @author {Yang}
     * @param  {[date]} selectedDate [선택 날짜]
     */
    onClickAddColumn(date) {
      this.selectedDate = new Date(date);
      this.settingWorkPopupOpen('ADD');
    },
    /**
     * CalendarHeader 이전,이후 월 이동
     * @author jeee12
     * @param  {Date} start        시작일
     * @param  {Date} end          종료일
     * @param  {Date} currentStart 해당 월의 시작일
     * @param  {Date} current      현재 날짜
     */
    changeMonth(start, end, currentStart, current) {
      this.selectedDate = current;
      this.loadStore();
    },
    /**
     * 작업 목록 테이블 searchTool show토글
     * @author jeee12
     */
    onClickTableSearchButton() {
      this.$refs.workListTable.onClickSetSearchToolVisible();
    },
    /**
     * 작업내역 (달력) 검색 input enter / icon click
     * @author jeee12
     */
    searchFilter() {
      this.$refs.workCalendar.search(this.calendarFilterValue);
    },
    /**
     * 달력의 날짜 영역 클릭
     * @author jeee12
     * @param  {[type]} date [description]
     */
    onClickCalendarNumber(date) {
      this.selectedDate = date.date;
      this.settingWorkPopupOpen('ADD');
    },
    reload() {
      this.loadStore();
      this.onChangedDatepicker();
      this.basicinfoSubloadStore();
    },
    /**
     * [loadStore 작업관리 내역 필터링 출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    loadStore() {
      this.cleanData();
      const params = {
        selectedDate: this.selectedDate,
      };
      workManageAPI.getWorkFilteringList(params).then((result) => {
        if (result.data.success === true) {
          const resultDatas = result.data.data;
          this.filteringDatas = resultDatas;
        }
      });
    },
    /**
     * [onChangedDatepicker left 달력에 데이터 출력]
     * @author {Yang}
     * @param  {[type]} nextDate [description]
     * @return {[type]}          [description]
     */
    onChangedDatepicker(nextDate) {
      const selectedDate = isNil(nextDate.timestamp) ? nextDate : nextDate.timestamp;
      workManageAPI
        .getWorkListForCalendar({
          selectedDate,
        })
        .then((response) => {
          if (response.data.success === true) {
            const resultSortDatas = reverse(sortBy(response.data.data, ['workImpact']));
            const highlightRanges = [];
            resultSortDatas.forEach((item) => {
              const workimpact = isNil(item.workImpact) ? 'GRADE_NULL' : item.workImpact;
              highlightRanges.push({
                from: new Date(item.startDatetime),
                to: new Date(item.endDatetime),
                workimpact,
              });
            });
            this.highlighted.ranges = highlightRanges;
          }
        });
    },
    /**
     * [cleanData 작업관리 내역 필터링 초기화]
     * @author {Yang}
     * @return {[type]} [description]
     */
    cleanData() {
      this.filteringDatas = [];
    },
    openDatailPopup(data) {
      this.$store.dispatch('openWorkDetailsSlidingPopup', data);
    },
    /**
     * [reloadStore 리로드]
     * @author {Yang}
     * @return {[type]} [description]
     */
    reloadStore() {
      this.loadStore();
      this.onChangedDatepicker(this.selectedDate);
      this.$nextTick(() => {
        this.$refs.workListTable.loadStore();
        this.$refs.workCalendar.loadData();
      });
    },
    /**
     * [basicinfoSubloadStore 작업별 필터링 정보 로드]
     * @author {Yang}
     */
    basicinfoSubloadStore() {
      workManageAPI.getBasicInfoSubList().then((response) => {
        if (response.data.success === true) {
          this.basicinfoSubDatas = response.data.data;
        }
      });
    },
    /**
     * 설정 팝업 닫기시 reload
     * @author jeee12
     */
    onSettingPopupClose() {
      this.$store.dispatch('closeWorkDetailsSlidingPopup');
      this.reloadStore();
    },
    getWorkTypeStyleClass(basicinfoSubid) {
      const classes = ['work-filtering-box'];
      if (!isNil(basicinfoSubid)) {
        classes.push(`work-${basicinfoSubid.toLowerCase()}`);
      }
      return classes;
    },
    openAmsSlidingPopup() {
      this.$refs.amsSlidingPopup.open();
    },
  },
};
</script>

<style lang="scss">
.el-radio-group {
  // margin-top: -2px;
}
.work-filtering-box {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  height: 13px;
  width: 25px;
  margin-left: 12px;
  //0402 수정
  &.work-construct {
    background-color: #e5f2ff;
    border-left: 3px solid #6aa4db;
  }
  &.work-check {
    background-color: #f0e7f7;
    border-left: 3px solid #aa81d2;
  }
  &.work-change {
    background-color: #e3f3ef;
    border-left: 3px solid #78b8aa;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
  }
}
.impact-work-box {
  height: 9px;
  width: 9px;
  border-radius: 50%;
  margin-left: 10px;
}

.calender-work-list {
  h4 {
    border-top: 1px solid #efefef;
    padding: 20px 20px 14px;
    font-size: 15px;
    // font-weight: bold;
    margin-bottom: 0;
  }

  .el-checkbox-group {
    overflow: hidden;
    padding: 0 20px 18px;

    & > div {
      padding-bottom: 3px;
    }
    .el-checkbox {
      display: flex;
      align-items: center;
      width: 100%;
    }
    .el-checkbox__inner {
      margin: 0;
    }
    .el-checkbox__label {
      // line-height: 14px; //initial;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 8px !important;
    }
    .txt {
      display: flex;
      align-items: center;
      margin-top: 0.5px;
      color: #666;
      line-height: initial;
    }
    .num {
      color: #444;
      margin-top: 0.5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/work/index.vue